// ===== Interfaces =====

import {
    IPreviewAudioEndPrompt,
    IPreviewAudioEndPromptInput,
}                                           from '../interfaces';

// ===== Enums =====

import {
    PREVIEW_AUDIO_END_PROMPT_ACCESS_TYPE,
    PREVIEW_AUDIO_END_PROMPT_SCOPE,
}                                           from '../enums';

/**
 * Root preview playback refers to the whole post. Nested scopes swap the noun
 * so the spoken prompt matches the reader's current location.
 */
export function resolvePreviewAudioEndPromptScope(
    selectedPostValuePath: number[],
): PREVIEW_AUDIO_END_PROMPT_SCOPE {
    if (selectedPostValuePath.length === 0) {
        return PREVIEW_AUDIO_END_PROMPT_SCOPE.post;
    }

    if (selectedPostValuePath.length === 1) {
        return PREVIEW_AUDIO_END_PROMPT_SCOPE.chapter;
    }

    return PREVIEW_AUDIO_END_PROMPT_SCOPE.section;
}

/**
 * Build the spoken footer that clarifies preview playback ended because access
 * is locked, not because the underlying audio itself is complete.
 */
export default function resolvePreviewAudioEndPrompt(
    data: IPreviewAudioEndPromptInput,
): IPreviewAudioEndPrompt {
    const {
        accessType,
        scope,
    } = data;

    if (accessType === PREVIEW_AUDIO_END_PROMPT_ACCESS_TYPE.authLocked) {
        return {
            accessType,
            scope,
            text: `That's the end of the preview audio. If you'd like to keep listening, sign in or join our mailing list at the bottom of the page to access the rest of this ${scope}.`,
        };
    }

    return {
        accessType,
        scope,
        text: "That's the end of the preview audio. If you'd like to keep listening, buy the book to access the full audio.",
    };
}
